import { gql } from '@apollo/client';
const GET_MODEL_SPECIFICATION_PROBLEMS = gql `
  query GetModelProblems($modelSpecificationId: ID!) {
    node(id: $modelSpecificationId) {
      ... on ModelSpecificationNode {
        confirmationProblems {
          id
          problemType
          blocksEstimatedCostCalculation
          blocksSpecificationConfirmation
          components {
            id
            nodeId
            nodeName
          }
          componentVariants {
            id
            nodeId
            nodeName
          }
        }
        estimatedCostCalculationProblems {
          id
          problemType
          blocksEstimatedCostCalculation
          blocksSpecificationConfirmation
          components {
            id
            nodeId
            nodeName
          }
          componentVariants {
            id
            nodeId
            nodeName
          }
        }
      }
    }
  }
`;
export default GET_MODEL_SPECIFICATION_PROBLEMS;
